class initConfigProvider {
   constructor() {
       this.Config = InitConfig;
   }
   $get() {
       return this.Config;
   }
}

export default initConfigProvider;


// WEBPACK FOOTER //
// ./app/initconfig.provider.js